module.exports = __webpack_public_path__ + "static/media/AmazonHoneycode101Badge.afe70435.png";